import { render, staticRenderFns } from "./EachResource.vue?vue&type=template&id=05131ae7&scoped=true&"
import script from "./EachResource.vue?vue&type=script&lang=js&"
export * from "./EachResource.vue?vue&type=script&lang=js&"
import style0 from "./EachResource.vue?vue&type=style&index=0&id=05131ae7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05131ae7",
  null
  
)

export default component.exports